var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bo-text-block"},_vm._l((_vm.textblocks),function(text){return _c('div',{key:text.index,class:[
            'text-content',
            text.alignment,
        ]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(text.title))]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(text.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }